const PbxxRecord = require('../pbxx_record')

module.exports = class RetailerAccount extends PbxxRecord {
  static get class_name() {
    return 'RetailerAccount'
  }

  get brands() {
  	let brands = []

  	_.forEach(this.retailers, function(retailer) {
  	  brands.push(retailer.brand)
  	})

    // remove duplicates and sort alphabetically ascending
    return _.sortBy(_.uniq(brands), ['name'])
  }

  get_retailer_by_brand(brand_id) {
    return _.find(this.retailers, (retailer) => {
      return retailer.brand_id === brand_id || (retailer.brand && retailer.brand.slug === brand_id)
    })
  }

}
